import { format, isSameDay, isTomorrow, isYesterday } from "./date-fns";
import type { Time } from "./time";
/**
 * Returns a relative date term (i.e. Yesterday, Today, or Tomorrow) for the relative timestamp compared with the anchor timestamp.
 * If it cannot be represented with a date term, the relative timestamp is returned as a dd/MM/yyyy date string
 *
 * @param anchorTime The timestamp in milliseconds to calculate from
 * @param relativeTimestampMs The timestamp relative to the anchor
 * @returns The relative date term, or a dd/MM/yyyy formatted date string
 */

export const toRelativeDateTerm = (anchorTime: Time, relativeTime: Time): string => {
	if (isSameDay(anchorTime, relativeTime)) {
		return "Today";
	}

	if (isYesterday(relativeTime, { now: anchorTime })) {
		return "Yesterday";
	}

	if (isTomorrow(relativeTime, { now: anchorTime })) {
		return "Tomorrow";
	}

	return format(relativeTime, "dd/MM/yyyy");
};
